import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { IRawFrameInfo } from '../main/frameInfo'
import { frameInfo } from '../main/frameInfo-sidecar'
import { scene } from '../main/scene-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { IStevieText } from './stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { phaserUtil } from '../engine/phaserUtil-sidecar'

export interface ICheckbox extends IEntity {
  // image: Phaser.GameObjects.Image
  text: IStevieText
  imageBackground: Phaser.GameObjects.Image
  isOver: boolean
  isDown: boolean
  frames: IRawFrameInfo[]
  getVal: () => boolean
  onClick: (newVal: boolean) => void
}

const objs: ICheckbox[] = []

let w = 50
let h = 10
let oy = (h + 2) * 6
export const defaultFrames: IRawFrameInfo[] = [
  frameInfo.fiRaw(4, 2, oy + 2, w, h),
  frameInfo.fiRaw(4, 2, oy + 2 + h + 2, w, h),
  frameInfo.fiRaw(4, 2, oy + 2 + 2 + 2 + h + h, w, h),
  // disabled: frameInfo.fi32(1, 5, 10),
  // bought: frameInfo.fi32(1, 5, 11),
]

export function create(
  layer: Phaser.GameObjects.Container,
  x: number,
  y: number,
  text: string,
  getVal: () => boolean,
  onClick: (newVal: boolean) => void,
  frames: IRawFrameInfo[] = defaultFrames,
) {
  let imageBackground = spriteMap.createImageFromRawFrameInfo(
    layer,
    frames[0] || defaultFrames[0],
    x,
    y,
    4,
  )

  let _text = stevieText.create(
    scene.getContext().font16,
    x + 10 + 4 + 34,
    y + 10,
  )
  stevieText.setText(_text, text)

  let obj: ICheckbox = {
    eType: 'button',
    id: common.createId(),
    imageBackground,
    isDown: false,
    isOver: false,
    text: _text,
    frames,
    getVal,
    onClick,
    isDead: false,
  }
  objs.push(obj)

  phaserUtil.setInteractive(imageBackground)

  imageBackground.on('pointerover', () => {
    obj.isOver = true
  })
  imageBackground.on('pointerout', () => {
    obj.isOver = false
  })

  imageBackground.on('pointerdown', () => {
    obj.onClick(!obj.isDown)
  })
  imageBackground.on('pointerup', () => {
    // if (obj.imageBackground.visible) {
    //   obj.onClick()
    // }
  })
  return obj
}

export function setVisible(obj: ICheckbox, visible: boolean) {
  obj.imageBackground.visible = visible
  stevieText.setVisible(obj.text, visible)
}

export function kill(obj: ICheckbox) {
  obj.isDead = true
}

export function updateAll() {
  l.forEach(objs, (c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.imageBackground.destroy()
    stevieText.kill(c.text)
  })
}

export function update(obj: ICheckbox) {
  if (!obj.imageBackground.visible) {
    return
  }
  obj.isDown = obj.getVal()

  if (obj.isDown) {
    spriteMap.setRawFrame(
      obj.imageBackground,
      obj.frames[2] || defaultFrames[2],
      0,
      0,
    )
  } else if (obj.isOver) {
    spriteMap.setRawFrame(
      obj.imageBackground,
      obj.frames[1] || defaultFrames[1],
      0,
      0,
    )
  } else {
    spriteMap.setRawFrame(
      obj.imageBackground,
      obj.frames[0] || defaultFrames[0],
      0,
      0,
    )
  }
}
